/* ============================================================
   DevlopMint × Sportkipik — Écosse vs NZ 2026
   Interactions design + câblage Shopify (variantes réelles).
   Acompte = variant.price · Total = variant.compare_at_price (35%).
   ============================================================ */
(function () {
  'use strict';

  // Mémorise la page pour "Retour vers le site" depuis le panier.
  try { localStorage.setItem('dm_return_url', window.location.pathname); } catch (e) {}

  /* ---------- Sticky header ---------- */
  var header = document.getElementById('header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el, i) { el.style.transitionDelay = (Math.min(i % 4, 3) * 60) + 'ms'; io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- FAQ accordion ---------- */
  var faqs = document.querySelectorAll('.faq__item');
  faqs.forEach(function (item) {
    var q = item.querySelector('.faq__q'); var a = item.querySelector('.faq__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      faqs.forEach(function (o) { o.classList.remove('is-open'); var oa = o.querySelector('.faq__a'); if (oa) oa.style.maxHeight = null; });
      if (!open) { item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });
  faqs.forEach(function (item) { if (item.classList.contains('is-open')) { var a = item.querySelector('.faq__a'); if (a) a.style.maxHeight = a.scrollHeight + 'px'; } });

  /* ---------- Itinéraire — accordéon par jour ---------- */
  var days = document.querySelectorAll('.day--acc');
  function setDayHeight(day) { var b = day.querySelector('.day__body'); if (!b) return; b.style.maxHeight = day.classList.contains('is-open') ? b.scrollHeight + 'px' : null; }
  days.forEach(function (day) {
    var head = day.querySelector('.day__head'); setDayHeight(day);
    if (!head) return;
    head.addEventListener('click', function () {
      var nowOpen = !day.classList.contains('is-open');
      day.classList.toggle('is-open', nowOpen);
      head.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      setDayHeight(day);
    });
  });
  window.addEventListener('resize', function () {
    var open = document.querySelector('.faq__item.is-open');
    if (open) { var a = open.querySelector('.faq__a'); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
    days.forEach(setDayHeight);
  });

  /* ---------- Widget réservation — câblé aux variantes réelles ---------- */
  var widget = document.getElementById('widget');
  if (widget) {
    var data = [];
    var dataEl = document.getElementById('sk-variant-data');
    if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = []; } }
    var ROOM = { shared: 'Chambre partagée', single: 'Chambre seule' };

    var roomRows = widget.querySelectorAll('.optrow');
    var flightBtns = widget.querySelectorAll('.toggle button');
    var totalEl = document.getElementById('w-total');
    var twoRow = document.getElementById('w-tworow');
    var twoEl = document.getElementById('w-two');
    var depEl = document.getElementById('w-deposit');
    var depTwoEl = document.getElementById('w-deposit-two');
    var form = document.getElementById('sk-product-form');
    var hidden = form ? form.querySelector('[data-variant-id]') : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var cta = document.getElementById('reserve-cta');

    var state = { roomKey: 'shared', flightKey: '0' };
    var selectedId = null;

    function fmt(n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €'; }
    function fmtDec(n) { var c = Math.abs(n - Math.round(n)) > 0.001; return n.toLocaleString('fr-FR', { minimumFractionDigits: c ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; }
    // Match par hébergement + présence de vol (robuste au prix dans le nom de l'option).
    function find(heb, wantFlight) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].heb !== heb) continue;
        var noFlight = (data[i].tr || '').toLowerCase().indexOf('sans vol') !== -1;
        if (wantFlight ? !noFlight : noFlight) return data[i];
      }
      return null;
    }

    function render() {
      var v = find(ROOM[state.roomKey], state.flightKey !== '0');
      if (!v) return;
      selectedId = v.id; if (hidden) hidden.value = v.id;
      // Chambre partagée = réservation par 2 (paire) ; chambre seule = 1.
      if (qtyInput) qtyInput.value = (state.roomKey === 'shared') ? 2 : 1;
      var total = (v.compare || v.price) / 100, dep = v.price / 100;
      if (totalEl) totalEl.innerHTML = fmt(total) + ' <small>/ pers</small>';
      if (depEl) depEl.innerHTML = fmtDec(dep) + '<small> / pers</small>';
      var shared = state.roomKey === 'shared';
      if (twoRow) { twoRow.hidden = !shared; if (shared && twoEl) twoEl.textContent = fmt(total * 2); }
      if (depTwoEl) { depTwoEl.hidden = !shared; if (shared) depTwoEl.textContent = 'soit ' + fmtDec(dep * 2) + ' pour 2 pers.'; }
      if (cta) {
        if (v.available === false) { cta.textContent = 'Sold out'; cta.disabled = true; cta.classList.add('is-disabled'); }
        else { cta.textContent = 'Réserver ma place'; cta.disabled = false; cta.classList.remove('is-disabled'); }
      }
    }

    roomRows.forEach(function (row) {
      row.addEventListener('click', function () {
        roomRows.forEach(function (r) { r.classList.remove('is-active'); });
        row.classList.add('is-active');
        state.roomKey = row.getAttribute('data-room') || 'shared';
        render();
      });
    });
    flightBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        flightBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.flightKey = btn.getAttribute('data-flight') || '0';
        render();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (cta && cta.disabled) return;
        if (hidden && selectedId) hidden.value = selectedId;
        if (cta) { cta.disabled = true; cta.textContent = 'Ajout en cours…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add_failed'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      });
    }
    render();
  }

  /* ---------- Capture email (form client Shopify, tag notify-sportkipik) ---------- */
  function wireCapture(form) {
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) { email.reportValidity(); return; }
      try { localStorage.setItem('skp_lead', email ? email.value : '1'); } catch (err) {}
      var btn = form.querySelector('button[type="submit"]'); if (btn) { btn.disabled = true; }
      var ok = form.parentNode.querySelector('.capture__ok');
      function done() { form.hidden = true; if (ok) ok.hidden = false; }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } }).then(done).catch(done);
    });
  }
  document.querySelectorAll('form.capture__form').forEach(wireCapture);

  /* ---------- Exit-intent popup (desktop, une fois) ---------- */
  var pop = document.getElementById('exitpop');
  if (pop && window.matchMedia('(min-width: 901px) and (pointer: fine)').matches) {
    var shown = false;
    try { shown = !!localStorage.getItem('skp_exit_shown') || !!localStorage.getItem('skp_lead'); } catch (e) {}
    var showPop = function () { if (shown) return; shown = true; try { localStorage.setItem('skp_exit_shown', '1'); } catch (e) {} pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-open'); }); };
    var closePop = function () { pop.classList.remove('is-open'); setTimeout(function () { pop.hidden = true; }, 280); };
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) showPop(); });
    pop.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) closePop(); });
  }

  /* ---------- Pop-up sold-out : CTA WhatsApp (plus de liste d'attente email) ---------- */
  (function () {
    var modal = document.getElementById('skSoldoutModal');
    if (!modal) return;
    var KEY = 'skp_soldout_' + window.location.pathname;
    function remember() { try { localStorage.setItem(KEY, '1'); } catch (err) {} }
    function open() { modal.hidden = false; requestAnimationFrame(function () { modal.classList.add('is-open'); }); }
    // On mémorise à la fermeture : sans formulaire à soumettre, c'est le seul signal
    // qui évite de réafficher la pop-up à chaque visite.
    function close() { remember(); modal.classList.remove('is-open'); setTimeout(function () { modal.hidden = true; }, 240); }
    Array.prototype.forEach.call(modal.querySelectorAll('[data-close]'), function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    var wa = modal.querySelector('.sk-modal__wa');
    if (wa) wa.addEventListener('click', remember);
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (e) {}
    if (!seen) setTimeout(open, 600);
  })();
})();
